exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-3313b3f5] .ant-modal-body {\n  padding: 10px 24px 24px 24px;\n}\n.modal-container[data-v-3313b3f5] .ant-form-item {\n  margin-bottom: 0px;\n}\n", ""]);

// exports
